
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LoadingOverlay extends Vue {
    @Prop({ default: false }) show!: boolean;
    @Prop({ default: 'Loading...' }) message!: string;
}
